export function handleFacetSortCriterionUpdate(state, payload) {
    const { facetId, criterion } = payload;
    const facetRequest = state[facetId]?.request;
    if (!facetRequest) {
        return;
    }
    facetRequest.sortCriteria = criterion;
}
export function handleFacetDeselectAll(facetRequest) {
    if (!facetRequest) {
        return;
    }
    facetRequest.currentValues = facetRequest.currentValues.map((value) => ({
        ...value,
        ...{ previousState: value.state !== 'idle' ? value.state : undefined },
        state: 'idle',
    }));
    facetRequest.preventAutoSelect = true;
}
export function handleFacetUpdateNumberOfValues(facetRequest, numberOfValues) {
    if (!facetRequest) {
        return;
    }
    facetRequest.numberOfValues = numberOfValues;
}
